import React from "react";
import { Heading } from "@/shared/components/ui/Heading";
import { useModal } from "@/shared/contexts/ModalProvider";
import FullCoverageDetailsContent from "@/shared/components/FullCoverageDetailsModal";
import Strings from "@/shared/utils/Strings.constants";
import FullCoverageDetailsButton from "../FullCoverageDetailsButton";
import MultipetToggle from "../MultipetToggle";
import { CoverageSettings, Policy } from "@/shared/types/Quote.interface";
import { WaitingPeriods } from "@/shared/components/FullCoverageDetailsModal/coverageData";
import OneIcon from "@/shared/media/icons/one.svg";
import { cn } from "@/shared/utils";

interface PetData {
    activePet?: any;
    policies?: Policy[];
    allPetsHaveSameCoverages: boolean;
    quoteId?: string;
}

interface CoverageDisplayConfig {
    samplePolicyUrl: string;
    showTelehealth?: boolean;
    isDentalCovered?: boolean;
    isMicrochippingCovered?: boolean;
    preExistingConditions?: string;
    waitingPeriods?: WaitingPeriods;
    showCompellingStats?: boolean;
    showBreedSpecificConditions?: boolean;
    hasAnyBreedConditions?: boolean;
}

interface CoverageSectionHeaderProps {
    petData: PetData;
    displayConfig: CoverageDisplayConfig;
    updateCoverageSettings: (newCoverageSettings: CoverageSettings | null, isApplyToAllPetsChecked: boolean, petId?: string) => Promise<void>;
    showStepLabel?: boolean;
    showNumbered?: boolean;
    showFullCoverageDetails?: boolean;
    showDetailsCtaGravitas?: boolean;
}

export const CoverageSectionHeader: React.FC<CoverageSectionHeaderProps> = props => {
    const { petData, displayConfig, updateCoverageSettings, showStepLabel, showNumbered, showFullCoverageDetails, showDetailsCtaGravitas } = props;
    const { quoteId, policies, allPetsHaveSameCoverages, activePet } = petData;
    const { showModal } = useModal();

    const handleOpenModal = () => {
        const modalProps = {
            ...petData,
            ...displayConfig,
            updateCoverageSettings,
            showStepLabel
        };
        showModal("coverage-details-modal", <FullCoverageDetailsContent {...modalProps} />, Strings.COVERAGE_DETAILS);
    };

    return (
        <div className={cn("flex items-center justify-between", showNumbered && "mb-1")}>
            <div className="flex items-center gap-3">
                <Heading level="h1" className={cn("text-sm font-semibold", showNumbered && "flex items-center gap-1 text-base font-bold leading-5")}>
                    {showNumbered && <OneIcon className="size-6" />}
                    {showFullCoverageDetails ? Strings.PTZ_US.CUSTOMIZE_PLAN : "Coverage"}
                </Heading>

                {props.showStepLabel && (
                    <MultipetToggle
                        quoteId={quoteId}
                        policies={policies}
                        allPetsHaveSameCoverages={allPetsHaveSameCoverages}
                        activePet={activePet}
                        updateCoverageSettings={updateCoverageSettings}
                        fieldId="all-pets-coverage-header"
                        wrapperClass="hidden sm:flex"
                    />
                )}
            </div>
            {/* In-header button: control shows at all sizes; with the test on it stays only on sm+ (2xs/xs uses the below-header button) */}
            <div className={cn(showFullCoverageDetails && "hidden sm:block")}>
                <FullCoverageDetailsButton onClick={handleOpenModal} showDetailsCtaGravitas={showDetailsCtaGravitas} />
            </div>
        </div>
    );
};
